import * as z from "zod";
import { gql } from "graphql-request";
import { SysSchema, SysFragment } from "../sys";
import { ImageSchema, ImageFragment } from "../image";

export const PollOptionSchema = z.object({
  id: z.string(),
  title: z.string().nullable().optional(),
  image: z
    .object({
      id: z.string(),
      title: z.string(),
      width: z.number(),
      height: z.number(),
      url: z.string(),
    })
    .nullable()
    .optional(),
});

export const PollOptionsArraySchema = z.array(PollOptionSchema).nullish();

export const PollOptionsArray = PollOptionsArraySchema;
export type PollOptionsArray = z.infer<typeof PollOptionsArraySchema>;

// Contentful field is type "Object" (arbitrary JSON), so legacy entries can
// hold a non-array value here. The site read path falls back to [] so a bad
// entry doesn't crash the static build; getPollOptions also guards with
// Array.isArray. Writers (Phrase, poll-api) still use the strict schema.
export const PollBaseSchema = z.object({
  pollTitle: z.string().nullable(),
  pollOptions: PollOptionsArraySchema.catch([]),
});

export const CarouselEventPollEntrySchema = PollBaseSchema.extend({
  __typename: z.literal("CarouselEventPollEntry"),
  sys: SysSchema,
  entryTitle: z.string().nullable(),
  entryHideTitle: z.boolean().nullable(),
  carouselImage: ImageSchema.nullable(),
  carouselImageEn: ImageSchema.nullable(),
});

export type CarouselEventPollEntry = z.infer<
  typeof CarouselEventPollEntrySchema
>;

export const CarouselEventPollEntryFragment = gql`
  fragment CarouselEventPollEntryFragment on CarouselEventPollEntry {
    __typename
    sys {
      ...SysFragment
    }

    entryTitle
    entryHideTitle
    pollTitle
    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }

    pollOptions
  }

  ${SysFragment}
  ${ImageFragment}
`;
